import React, { Component } from 'react';
import { Modal, ButtonToolbar, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';

class Dialog extends Component {

	constructor(props) {
		super(props);
	}

	renderFooter(config) {
		const { footer, onHide } = config;

		let content;
		if (footer) {
			content = footer;
		} else {
			const closeButton = <Button onClick={onHide}>Close</Button>;
			content = closeButton;
		}

		return (
			<Modal.Footer>
				{content}
			</Modal.Footer>
		);
	}

	renderHeader(config) {
		const { header } = config;
		return (
			<Modal.Header closeButton>
				<Modal.Title>
					{header}
				</Modal.Title>
			</Modal.Header>
		);
	}

	renderBody(config) {
		const { body } = config;
		return (
			<Modal.Body>
				{body}
			</Modal.Body>
		);
	}

	render() {
		const { config, show, block, unblock, ...rest } = this.props;
		return <Modal
			{...rest}
			show={show}
			onHide={config.onHide}>
			<ReduxBlockUi block={block} unblock={unblock}>
				{this.renderHeader(config)}
				{this.renderBody(config)}
				{this.renderFooter(config)}
			</ReduxBlockUi>
		</Modal>;
	}
}

Dialog.propTypes = {
	config: PropTypes.shape({
		onHide: PropTypes.func.isRequired,
		header: PropTypes.node.isRequired,
		body: PropTypes.node.isRequired,
		footer: PropTypes.node
	}),
	show: PropTypes.bool
};

export default Dialog;